export enum DocumentStateEnum {
    NONE, PROCESSING, READY
}
